import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useTranslation } from "react-i18next";
import { DailyMetric } from "../../api/types";

const TYPE_KEYS = [
  "view_story",
  "like_story",
  "like_post",
  "send_dm",
  "follow",
  "unfollow",
  "comment",
] as const;

const TYPE_COLORS: Record<(typeof TYPE_KEYS)[number], string> = {
  view_story: "#60a5fa",
  like_story: "#a78bfa",
  like_post: "#ec4899",
  send_dm: "#34d399",
  follow: "#f472b6",
  unfollow: "#94a3b8",
  comment: "#fbbf24",
};

export default function DailyActionsChart({ data }: { data: DailyMetric[] }) {
  const { t } = useTranslation();
  const series = data.map((d) => ({
    date: d.date,
    ...d.interactionsByType,
  }));

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={series}>
        <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
        <XAxis dataKey="date" tick={{ fill: "#94a3b8", fontSize: 12 }} />
        <YAxis tick={{ fill: "#94a3b8", fontSize: 12 }} />
        <Tooltip
          contentStyle={{
            background: "#0f172a",
            border: "1px solid #334155",
            borderRadius: 8,
            color: "#e2e8f0",
          }}
        />
        <Legend wrapperStyle={{ color: "#cbd5e1", fontSize: 12 }} />
        {TYPE_KEYS.map((key) => (
          <Bar
            key={key}
            dataKey={key}
            stackId="a"
            fill={TYPE_COLORS[key]}
            name={t(`interaction.typePlural.${key}`)}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
